import PropTypes from 'prop-types';
import { List } from 'immutable';
import ChatHeadingConfigPropType from 'conversations-prop-types/prop-types/ChatHeadingConfigPropType';
import { RIGHT_ALIGNED, WidgetLocationProp } from '../constants/WidgetLocations';
// @ts-expect-error untyped file
import WidgetHeader from './WidgetHeader';
import VisitorWidgetStyleWrapper from '../../presentation-components/VisitorWidgetStyleWrapper';
import { HEADER_HEIGHT } from '../../widget-dimensions/constants/dimensions';
import styled from 'styled-components';
import WidgetViews from '../proptypes/WidgetViews';
import { THREAD_VIEW } from '../constants/views';
import { getBrandStyle } from '../util/color';
import KBNavigation from './KBNavigation';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WidgetBodyDiv = styled.div.withConfig({
  displayName: "VisitorWidget__WidgetBodyDiv",
  componentId: "sc-7voz7-0"
})(["display:flex;flex-direction:column;height:100%;background-color:#fff;overflow:hidden;border-start-end-radius:10px;"]);
export const WidgetBodyDivWrapper = styled.div.withConfig({
  displayName: "VisitorWidget__WidgetBodyDivWrapper",
  componentId: "sc-7voz7-1"
})(["height:", ";", ";"], ({
  kbNavigationEnabled,
  isOnSearchMode
}) => `calc(100% - ${isOnSearchMode ? 0 : HEADER_HEIGHT}px - ${kbNavigationEnabled ? 72 : 0}px)`, ({
  $background
}) => getBrandStyle($background));
const VisitorWidget = ({
  backButtonDisabled,
  browserWindowHeight,
  browserWindowWidth,
  chatHeadingConfig,
  chatHeadingResponders,
  children,
  closeWidget,
  coloring,
  createNewThread,
  customHeaderText = null,
  inline = false,
  isPreview = false,
  isThreadAssigned = false,
  kbArticleDeepLink,
  restorePreviousViewFromKBArticle,
  mobile = false,
  navigateToKnowledgeBaseArticle,
  navigateToThreadList,
  officeHoursMessage,
  sdkCloseButtonClickHandler,
  setWidgetSize,
  showAvailabilityMessage,
  showBackButton,
  size,
  style,
  toggleWidgetSizeForKBArticle,
  typicalResponseTimeMessage,
  unseenThreadsCountExcludingCurrentThread,
  view = THREAD_VIEW,
  viewKBArticleExpanded,
  widgetLocation = RIGHT_ALIGNED,
  widgetSize,
  updateView,
  kbNavigationEnabled,
  isOnSearchMode
}) => {
  const [isHeaderAnimating, setIsHeaderAnimating] = useState(false);
  const handleAnimationEntered = () => {
    setIsHeaderAnimating(false);
  };
  const handleAnimationExited = () => {
    setIsHeaderAnimating(true);
  };
  return /*#__PURE__*/_jsxs(VisitorWidgetStyleWrapper, {
    browserWindowHeight: browserWindowHeight,
    browserWindowWidth: browserWindowWidth,
    inline: inline,
    size: size,
    style: style,
    mobile: mobile,
    widgetLocation: widgetLocation,
    widgetSize: widgetSize,
    children: [/*#__PURE__*/_jsx(WidgetHeader, {
      backButtonDisabled: backButtonDisabled,
      browserWindowHeight: browserWindowHeight,
      chatHeadingConfig: chatHeadingConfig,
      coloring: coloring,
      chatHeadingResponders: chatHeadingResponders,
      createNewThread: createNewThread,
      customHeaderText: customHeaderText,
      inline: inline,
      isThreadAssigned: isThreadAssigned,
      kbArticleDeepLink: kbArticleDeepLink,
      restorePreviousViewFromKBArticle: restorePreviousViewFromKBArticle,
      mobile: mobile,
      navigateToKnowledgeBaseArticle: navigateToKnowledgeBaseArticle,
      navigateToThreadList: navigateToThreadList,
      officeHoursMessage: officeHoursMessage,
      onClose: closeWidget,
      preview: isPreview,
      sdkCloseButtonClickHandler: sdkCloseButtonClickHandler,
      toggleWidgetSizeForKBArticle: toggleWidgetSizeForKBArticle,
      setWidgetSize: setWidgetSize,
      showAvailabilityMessage: showAvailabilityMessage,
      showBackButton: showBackButton,
      typicalResponseTimeMessage: typicalResponseTimeMessage,
      unseenThreadsCountExcludingCurrentThread: unseenThreadsCountExcludingCurrentThread,
      view: view,
      viewKBArticleExpanded: viewKBArticleExpanded,
      isOnSearchMode: isOnSearchMode,
      handleAnimationEntered: handleAnimationEntered,
      handleAnimationExited: handleAnimationExited,
      kbNavigationEnabled: kbNavigationEnabled
    }), /*#__PURE__*/_jsx(WidgetBodyDivWrapper, {
      $background: coloring.accentColor,
      kbNavigationEnabled: kbNavigationEnabled,
      isOnSearchMode: isOnSearchMode,
      children: /*#__PURE__*/_jsx(WidgetBodyDiv, {
        children: children
      })
    }), kbNavigationEnabled && !isHeaderAnimating && /*#__PURE__*/_jsx(KBNavigation, {
      view: view,
      updateView: updateView
    })]
  });
};
VisitorWidget.propTypes = {
  backButtonDisabled: PropTypes.bool,
  browserWindowHeight: PropTypes.number.isRequired,
  browserWindowWidth: PropTypes.number.isRequired,
  chatHeadingConfig: ChatHeadingConfigPropType.isRequired,
  chatHeadingResponders: PropTypes.instanceOf(List),
  children: PropTypes.node.isRequired,
  closeWidget: PropTypes.func.isRequired,
  coloring: PropTypes.object.isRequired,
  createNewThread: PropTypes.func,
  customHeaderText: PropTypes.string,
  inline: PropTypes.bool.isRequired,
  isOnSearchMode: PropTypes.bool.isRequired,
  isPreview: PropTypes.bool.isRequired,
  isThreadAssigned: PropTypes.bool.isRequired,
  kbArticleDeepLink: PropTypes.string,
  kbNavigationEnabled: PropTypes.bool,
  mobile: PropTypes.bool.isRequired,
  navigateToKnowledgeBaseArticle: PropTypes.func,
  navigateToThreadList: PropTypes.func,
  officeHoursMessage: PropTypes.string,
  restorePreviousViewFromKBArticle: PropTypes.func,
  sdkCloseButtonClickHandler: PropTypes.func,
  setWidgetSize: PropTypes.func,
  showAvailabilityMessage: PropTypes.bool,
  showBackButton: PropTypes.bool.isRequired,
  size: PropTypes.string,
  style: PropTypes.object,
  toggleWidgetSizeForKBArticle: PropTypes.func,
  typicalResponseTimeMessage: PropTypes.string,
  unseenThreadsCountExcludingCurrentThread: PropTypes.number,
  updateIsOnSearchMode: PropTypes.func,
  updateView: PropTypes.func,
  view: WidgetViews,
  viewKBArticleExpanded: PropTypes.bool,
  widgetLocation: WidgetLocationProp,
  widgetSize: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }).isRequired
};
VisitorWidget.displayName = 'VisitorWidget';
export default VisitorWidget;